import React from "react";
import { Breadcrumb } from "../../../../components/Breadcrumb";
import { Button, SaveButton } from "../../../../components/Buttons";

export const Complect = () => {
    document.title = "Dəst";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Məhsullar", value: "/products" },
        { name: "Parametrlər", value: "/products/parameters" },
        { name: "Dəst", value: "/products/parameters/complect", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Dəst</h2>
                    <p>
                        Bir neçə məhsulu <b>Dəst</b> şəklində satmaq, almaq ... üçün nəzərdə tutulub. Misal üçün Mebel dəsti və Otaq papıları həm dəst şəklində
                        həm də tək tək satıla bilir. Və yaxud 2 və daha çox məhsulu birləşdirib satmaq olar.
                        <ol>
                            <li>
                                <Button>Dəst</Button> düyməsini sıxın.
                            </li>
                            <li>
                                Açılan pəncərədə Dəst üçün <b>Ad</b> təyin edin.
                            </li>
                            <li>
                                <Button>Məhsullar</Button> düyməsini sıxın və açılan pəncərədə Dəstin <b>tərkibinə</b> daxil olan məhsulları müəyyən edin
                            </li>
                            <li>
                                <Button>Əlavə et</Button> düyməsini sıxın və <SaveButton /> düyməsi ilə əməliyyatı tamamlayın.
                            </li>
                        </ol>
                    </p>
                    <img src="/images/products/parameters/complect.gif" alt="Dəst" />
                </article>
            </div>
        </div>
    );
};
